// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Box, Title } from '@nerdwallet/currency';
import FeatureBarItem from './feature-bar-item';

import Row from '../row/row';

// Utils
import {
  stringInputSpec,
  stringTextAreaSpec,
  backgroundColorPicker,
  textColorPicker,
  repeatable,
} from '../../lib/editing-configs';
import classColor from '../../lib/parse-color';

import './feature-bar.less';

const FeatureBar = ({
  title,
  features,
  featureBarClass,
  textColor,
  backgroundColor,
}) => (
  <Row backgroundColor={backgroundColor}>
    <Box className={classnames('feature-bar', featureBarClass)}>
      <Title
        className={classnames(['feature-bar__title', classColor(textColor)])}
        size="small"
      >
        {title}
      </Title>
      <Box className="feature-box">
        {features.map(({ name, description, iconUri }) => (
          <FeatureBarItem
            key={name}
            name={name}
            description={description}
            iconUri={iconUri}
          />
        ))}
      </Box>
    </Box>
  </Row>
);

FeatureBar.propTypes = {
  title: PropTypes.string,
  features: PropTypes.array,
  featureBarClass: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};

FeatureBar.defaultProps = {
  title: '',
  features: [],
  featureBarClass: '',
  textColor: 'neutral-darkest',
};

FeatureBar.getEditingConfig = () => [
  stringInputSpec('title', 'Title'),
  textColorPicker,
  backgroundColorPicker,
  repeatable('features', 'Features', 'Feature', () => [
    stringInputSpec('name', 'Header'),
    stringTextAreaSpec('description', 'Body'),
    stringInputSpec('iconUri', 'Icon name in out CDN'),
  ]),
];

export default FeatureBar;
